<template>
  <DialogUserShareTemplate
    :title-html="titleHtml"
    :app-event-share="appEventShare"
    :forced="forced"
  >
    <template #image>
      <div class="img-wrapper">
        <img
          v-if="type === 'pairing'"
          src="~/assets/images/popin-content-pairing.webp"
          srcset="~/assets/images/popin-content-pairing@2x.webp 2x"
          alt="Contenu Nomad+"
          width="362"
          height="278"
        />
        <img
          v-else
          src="~/assets/images/popin-content-default.webp"
          srcset="~/assets/images/popin-content-default@2x.webp 2x"
          alt="Contenu Nomad+"
          width="362"
          height="193"
        />
      </div>
    </template>
    <DialogUserShareEmailTemplate
      :description-html="descriptionHtml"
      :description-send-mail-complete-html="descriptionSendMailCompleteHtml"
      :default-email="defaultEmail"
      :data="data"
      :source-location="sourceLocation"
      :app-event-share="appEventShare"
      :forced="forced"
      :cancel="false"
      v-bind="attrs"
    />
  </DialogUserShareTemplate>
</template>
<script lang="ts" setup>
interface Props {
  type: string;
  titleHtml: string;
  descriptionHtml: string;
  descriptionSendMailCompleteHtml: string;
  defaultEmail?: string;
  data: any;
  sourceLocation: string;
  appEventShare: UseAppEventShare;
  forced: boolean;
}

defineProps({
  type: null,
  titleHtml: null,
  descriptionHtml: null,
  descriptionSendMailCompleteHtml: null,
  defaultEmail: { default: '' },
  data: null,
  sourceLocation: null,
  appEventShare: null,
  forced: { type: Boolean }
});

const attrs = useAttrs();
</script>
<style lang="scss" scoped>
.img-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: var(--gap_m) var(--gap_m) 0;
  border-width: var(--stroke_thickness_n);
  border-style: solid;
  border-radius: 1.2rem;
  border-color: var(--color_neutral_100);
  background-color: var(--color_neutral_80);

  :deep(img) {
    width: auto;
    height: 100%;
    max-height: 14rem;
    @include above('m') {
      max-height: 20rem;
    }
  }
}
</style>
